import React, { SyntheticEvent } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import "./categoryLink.scss";

type CategoryLinkProps = {
    superCategoryUrl: string;
    superCategoryName: string;
    className?: string;
};

const CategoryLink = ({
    superCategoryUrl,
    superCategoryName,
    className,
}: CategoryLinkProps) => {
    const { t } = useGranite();

    if (!superCategoryName || !superCategoryUrl) return null;

    const handleOnCategoryLinkClick = (event: SyntheticEvent) => {
        event.stopPropagation();
        event.preventDefault();
        window.location.href = superCategoryUrl;
    };

    return (
        <div className={className}>
            <Button
                type={"button"}
                color={"link"}
                onClick={handleOnCategoryLinkClick}
                className={
                    "px-0 py-2 w-100 d-flex text-decoration-none align-items-center"
                }
            >
                <span
                    className={
                        "categoryLink__name overflow-hidden small text-left text-underline-hover"
                    }
                >
                    {t("productTile.category.link", superCategoryName)}
                </span>
                <i className="categoryLink__icon las la-angle-right" />
            </Button>
        </div>
    );
};

export default CategoryLink;
